import { render } from "./PageOverlay.vue?vue&type=template&id=69472bbc&scoped=true"
const script = {}

import "./PageOverlay.vue?vue&type=style&index=0&id=69472bbc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69472bbc"]])

export default __exports__